import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "../lib/api";
import { useAdminAuth } from "./admin/AdminAuth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAdminAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    if (!sessionId) { navigate("/admin/login"); return; }
    exchangeSession(sessionId)
      .then((user) => {
        // CRITICAL: push the user into the AdminAuth context immediately, otherwise
        // ProtectedAdminRoute renders with user=null and bounces back to /admin/login.
        setUser(user);
        window.history.replaceState(null, "", window.location.pathname);
        if (user.role === "admin") navigate("/admin", { replace: true });
        else navigate("/", { replace: true });
      })
      .catch((err) => {
        const status = err?.response?.status;
        const detail = err?.response?.data?.detail;
        if (status === 403) {
          setError(detail || "This Google account is not authorised for admin access.");
        } else {
          setError("Authentication failed. Please try again.");
        }
        setTimeout(() => navigate("/admin/login", { replace: true }), 2500);
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#FDFCFB] px-4" data-testid="auth-callback">
      <div className="text-center max-w-md">
        <div className="h-10 w-10 mx-auto border-4 border-[#37B160] border-t-transparent rounded-full animate-spin" />
        <p className="mt-4 text-[#4B5563]">{error || "Signing you in…"}</p>
      </div>
    </div>
  );
}
